var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeyondAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 60,
    height: 60,
    rx: 11,
    transform: "translate(857 475)",
    fill: "#5d44ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 60,
    height: 60,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 23.089,
    height: 14.345,
    transform: "translate(33.081 8.104)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 16.352,
    height: 13.347,
    transform: "translate(16.021 8.078)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(-1211 -475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6",
    "data-name": "Mask Group 6",
    transform: "translate(354)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(857 475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M56.54,60H3.461A3.46,3.46,0,0,1,0,56.54V3.46A3.46,3.46,0,0,1,3.461,0H56.54A3.46,3.46,0,0,1,60,3.46V56.54A3.46,3.46,0,0,1,56.54,60",
    fill: "#5d44ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M36.894,45.261,36.5,41.51l7.6-.079,8.651,17.42-10.577-.358Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M52.751,58.916h0l-10.577-.358a.066.066,0,0,1-.058-.04L36.833,45.285l0-.017-.394-3.751a.066.066,0,0,1,.016-.05.064.064,0,0,1,.047-.021l7.6-.079a.064.064,0,0,1,.058.036l8.651,17.42a.064.064,0,0,1,0,.063.063.063,0,0,1-.054.03m-10.533-.485,10.428.353L44.061,41.5l-7.491.078.386,3.672Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M43.468,59.7,36.608,41.4h-.394a6.828,6.828,0,0,0-6.107,3.989L23.695,59.7Z",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M38.4,57.248a.063.063,0,0,1-.06-.041l-3.079-7.8a.064.064,0,0,1,.036-.083.065.065,0,0,1,.084.036l3.079,7.8a.065.065,0,0,1-.036.084.067.067,0,0,1-.024,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M56.456,49.446a1.357,1.357,0,0,1-.058-.14c-.151-.407-.453-1.139-.815-2a9.941,9.941,0,0,0-8.929-5.962c-1.516-.013-2.716-.022-2.739-.016l7.364,18.462h1.5a3.745,3.745,0,0,0,3.745-3.745Z",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M50.931,53.208,47.958,45.93,56.09,48.5,58.5,54.637a3.737,3.737,0,0,1-3.454,5.1c-3.825.027-8.582.055-12.2.051A22.367,22.367,0,0,0,40.6,53.349c5.274-.077,10.329-.141,10.329-.141",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M50.931,53.272H49.052a.065.065,0,0,1,0-.129h1.783L47.9,45.954a.064.064,0,0,1,.119-.049l2.973,7.278a.065.065,0,0,1-.06.089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M40.6,53.349a22.394,22.394,0,0,1,2.244,6.442c-2.966,0-9.239-.028-9.516-.094-.893-.21.52-6.348,7.272-6.348",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M52.752,53.392h0l-1.3-.05a.065.065,0,0,1,.006-.129l1.294.05a.065.065,0,0,1,0,.129"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M34.632,59.566H34.62a.063.063,0,0,1-.052-.074,4.794,4.794,0,0,1,4.585-3.972.065.065,0,0,1,.066.063.064.064,0,0,1-.062.066,4.663,4.663,0,0,0-4.463,3.865.063.063,0,0,1-.062.053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M36.343,59.426a.064.064,0,0,1-.057-.094,4.245,4.245,0,0,1,3.234-2.208.064.064,0,0,1,.015.127A4.116,4.116,0,0,0,36.4,59.392a.064.064,0,0,1-.057.034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M21.164,59.586H33.329L28.89,47.374a.872.872,0,0,0-.82-.575H15.939a.873.873,0,0,0-.821,1.171l3.6,9.9a2.6,2.6,0,0,0,2.447,1.714"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M38.076,58.058H18.735l.047.131A2.312,2.312,0,0,0,20.948,59.7H40.566a2.71,2.71,0,0,0-2.49-1.639"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M37.968,41.715l-.954-2.321s-.469-4.021,3.349-2.141l2.058,4.209c-1.017,1.7-3.156,2.129-4.453.253",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M40.065,43.005a2.622,2.622,0,0,1-2.15-1.254l-.006-.012-.955-2.32,0-.017c-.008-.073-.195-1.774.762-2.449.6-.421,1.5-.339,2.679.243a.065.065,0,0,1,.03.029l2.058,4.208a.068.068,0,0,1,0,.062A2.907,2.907,0,0,1,40.141,43h-.076m-2.04-1.321a2.478,2.478,0,0,0,2.112,1.191,2.77,2.77,0,0,0,2.211-1.417L40.315,37.3c-1.126-.55-1.977-.632-2.529-.243-.861.608-.722,2.189-.709,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M41.752,35.215a3.2,3.2,0,0,0,.569-1.69A1.329,1.329,0,0,0,41.3,32.213a1.861,1.861,0,0,0-2.693-2.07,2.542,2.542,0,0,0-2.867-.589,3.059,3.059,0,0,0-1.731,2.44,2.156,2.156,0,0,0,.215,1.306,2.129,2.129,0,0,0,1.547.961,1.072,1.072,0,0,1,1.265.939,2.878,2.878,0,0,0,1.544,1.691,2.633,2.633,0,0,0,2.176.042c.224-.144.266-.418.376-.649.177-.372.409-.716.62-1.069"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M34.854,35.615A3.742,3.742,0,0,0,35,38.594a2.3,2.3,0,0,0,4.184-.6,2.043,2.043,0,0,0,1.882-1.4.787.787,0,0,0-.164-.868c-.289-.213-.691-.045-1.022.094s-.582.387-.757.073c.126-.793.736-2.139-.428-2.533-.433-.147-2.857-.567-2.857-.567s-.832,2.293-.986,2.823",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M36.988,39.753a2.44,2.44,0,0,1-2.041-1.125,3.711,3.711,0,0,1-.155-3.031l.062.018-.062-.018c.153-.526.979-2.8.987-2.827a.065.065,0,0,1,.072-.041c.1.017,2.434.422,2.867.569,1,.34.756,1.37.575,2.122-.04.165-.078.321-.1.46.094.151.2.117.449-.015.068-.036.139-.072.216-.105.342-.143.767-.321,1.085-.086a.843.843,0,0,1,.188.938,2.1,2.1,0,0,1-1.9,1.445A2.431,2.431,0,0,1,37.3,39.732a2.314,2.314,0,0,1-.312.021m-1.106-6.888c-.123.341-.827,2.29-.966,2.768a3.591,3.591,0,0,0,.141,2.928,2.239,2.239,0,0,0,4.067-.584.065.065,0,0,1,.062-.047,1.967,1.967,0,0,0,1.821-1.356.735.735,0,0,0-.141-.8c-.26-.192-.631-.036-.959.1-.073.031-.141.066-.207.1-.228.119-.465.242-.631-.056a.065.065,0,0,1-.008-.041c.024-.149.064-.316.107-.492.188-.782.4-1.668-.492-1.97-.388-.132-2.436-.493-2.794-.555"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M39.518,36.994a.061.061,0,0,1-.042-.016.065.065,0,0,1-.007-.091,1.031,1.031,0,0,1,.855-.344.064.064,0,0,1-.011.128.9.9,0,0,0-.746.3.064.064,0,0,1-.049.022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M35.8,35.467a.8.8,0,1,1-.61-1,.829.829,0,0,1,.61,1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M34.995,36.235a.843.843,0,0,1-.156-.016.892.892,0,0,1-.66-1.073.953.953,0,0,1,.371-.591.818.818,0,0,1,.65-.149.893.893,0,0,1,.661,1.073.91.91,0,0,1-.866.756m.048-1.717a.7.7,0,0,0-.417.141.823.823,0,0,0-.321.511.732.732,0,1,0,.87-.639.738.738,0,0,0-.132-.013"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M37.272,36.687a.845.845,0,0,1-.158-.015.824.824,0,0,1-.543-.386.979.979,0,0,1,.254-1.279.814.814,0,0,1,1.193.237.976.976,0,0,1-.254,1.279.833.833,0,0,1-.492.164m.046-1.716a.707.707,0,0,0-.417.14.849.849,0,0,0-.22,1.108.685.685,0,0,0,1.007.2.848.848,0,0,0,.221-1.108.7.7,0,0,0-.459-.327.656.656,0,0,0-.132-.013"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M36.517,35.674a.064.064,0,0,1-.055-.031.444.444,0,0,0-.305-.246.425.425,0,0,0-.314.116.064.064,0,0,1-.09-.092.494.494,0,0,1,.819.156.065.065,0,0,1-.022.088.066.066,0,0,1-.033.009"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M38.073,35.984a.064.064,0,0,1-.007-.128l1.445-.155a.064.064,0,1,1,.014.128l-1.445.155h-.007"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 22.904,
    height: 14.196,
    transform: "translate(33.162 8.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M56.086,22.449H33.164a.083.083,0,0,1-.083-.083V8.187a.083.083,0,0,1,.083-.083H56.086a.084.084,0,0,1,.084.083V22.366a.084.084,0,0,1-.084.083m-22.838-.166H56V8.27H33.248Z",
    fill: "#e2eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M56.086,20.086H33.164a.083.083,0,0,1,0-.166H56.086a.083.083,0,1,1,0,.166",
    fill: "#e2eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M56.086,17.723H33.164a.083.083,0,1,1,0-.166H56.086a.083.083,0,0,1,0,.166",
    fill: "#e2eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M56.086,15.36H33.164a.083.083,0,1,1,0-.166H56.086a.083.083,0,1,1,0,.166",
    fill: "#e2eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M56.086,13H33.164a.083.083,0,1,1,0-.166H56.086a.083.083,0,1,1,0,.166",
    fill: "#e2eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M56.086,10.633H33.164a.083.083,0,1,1,0-.166H56.086a.083.083,0,1,1,0,.166",
    fill: "#e2eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M36.985,22.449a.083.083,0,0,1-.083-.083V8.187a.083.083,0,1,1,.166,0V22.366a.083.083,0,0,1-.083.083",
    fill: "#e2eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M40.805,22.449a.083.083,0,0,1-.083-.083V8.187a.083.083,0,0,1,.166,0V22.366a.083.083,0,0,1-.083.083",
    fill: "#e2eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M44.625,22.449a.083.083,0,0,1-.083-.083V8.187a.083.083,0,0,1,.166,0V22.366a.083.083,0,0,1-.083.083",
    fill: "#e2eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M48.446,22.449a.083.083,0,0,1-.083-.083V8.187a.083.083,0,1,1,.166,0V22.366a.083.083,0,0,1-.083.083",
    fill: "#e2eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M52.266,22.449a.083.083,0,0,1-.083-.083V8.187a.083.083,0,0,1,.166,0V22.366a.083.083,0,0,1-.083.083",
    fill: "#e2eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M33.58,21.959a.054.054,0,0,1-.025-.006.055.055,0,0,1-.024-.075l3.426-6.654a.054.054,0,0,1,.066-.027l7.513,2.479,7.879-4.894,3.233-4.221a.056.056,0,1,1,.088.068L52.5,12.858l-.014.013-7.911,4.913a.056.056,0,0,1-.047.006l-7.491-2.473-3.4,6.612a.054.054,0,0,1-.049.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M38.024,15.216a1.009,1.009,0,1,1-1.008-1.007,1.007,1.007,0,0,1,1.008,1.007",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M37.015,16.279a1.063,1.063,0,1,1,1.064-1.063,1.065,1.065,0,0,1-1.064,1.063m0-2.014a.952.952,0,1,0,.953.951.954.954,0,0,0-.953-.951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M45.555,17.662a1.009,1.009,0,1,1-1.008-1.007,1.007,1.007,0,0,1,1.008,1.007",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M44.547,18.725a1.063,1.063,0,1,1,1.064-1.063,1.065,1.065,0,0,1-1.064,1.063m0-2.014a.952.952,0,1,0,.953.951.954.954,0,0,0-.953-.951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M53.375,12.915a1.009,1.009,0,1,1-1.008-1.007,1.007,1.007,0,0,1,1.008,1.007",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M52.367,13.978a1.063,1.063,0,1,1,1.064-1.063,1.065,1.065,0,0,1-1.064,1.063m0-2.014a.952.952,0,1,0,.953.951.954.954,0,0,0-.953-.951"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M28.865,15.211a6.157,6.157,0,1,1-6.157-6.147,6.152,6.152,0,0,1,6.157,6.147",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M22.708,21.425a6.214,6.214,0,1,1,6.224-6.214,6.226,6.226,0,0,1-6.224,6.214m0-12.294a6.08,6.08,0,1,0,6.09,6.08,6.092,6.092,0,0,0-6.09-6.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M29.6,13.524a7.09,7.09,0,0,0-6.88-5.446v7.109s5.733-1.4,6.88-1.663",
    fill: "#e2eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M18.7,9.9a6.688,6.688,0,0,0-2.61,4.432c1.629.217,6.645.879,6.645.879S19.36,10.788,18.7,9.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M22.732,15.276h-.008c-.051-.007-5.035-.665-6.645-.88a.067.067,0,0,1-.045-.026.073.073,0,0,1-.013-.05,6.789,6.789,0,0,1,2.636-4.476.067.067,0,0,1,.1.014c.653.88,4,5.266,4.034,5.311a.067.067,0,0,1-.054.107m-6.568-1c1.5.2,5.56.736,6.417.85-.548-.719-3.23-4.236-3.9-5.13a6.654,6.654,0,0,0-2.52,4.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M32.306,11.885H25.547a.067.067,0,1,1,0-.134h6.759a.067.067,0,1,1,0,.134"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M29.339,17.733a.575.575,0,1,1,.574.573.573.573,0,0,1-.574-.573",
    fill: "#e2eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M27.663,17.733a.575.575,0,1,1,.574.573.573.573,0,0,1-.574-.573",
    fill: "#e2eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M25.987,17.733a.575.575,0,1,1,.574.573.573.573,0,0,1-.574-.573",
    fill: "#e2eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M25.387,17.8H21.695a.067.067,0,1,1,0-.134h3.692a.067.067,0,1,1,0,.134"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M8.014,32.005H15a2.053,2.053,0,0,1,2.041,2.269l-.72,6.793A2.052,2.052,0,0,1,14.278,42.9H8.84A2.054,2.054,0,0,1,6.8,41.1l-.825-6.793a2.052,2.052,0,0,1,2.037-2.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M14.278,42.943H8.84A2.1,2.1,0,0,1,6.762,41.1l-.826-6.793a2.094,2.094,0,0,1,2.078-2.346H15a2.094,2.094,0,0,1,2.081,2.314L16.36,41.07a2.089,2.089,0,0,1-2.082,1.873m-6.264-10.9a2.012,2.012,0,0,0-2,2.254l.826,6.794a2.013,2.013,0,0,0,2,1.768h5.438a2.008,2.008,0,0,0,2-1.8L17,34.268a2.011,2.011,0,0,0-2-2.223Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M7.788,35.445c.109,1.057-.078,1.942-.419,1.977s-.7-.793-.814-1.85.079-1.941.419-1.976.7.792.814,1.849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M5.942,39.916a.758.758,0,0,1-.664-1.109l1.815-3.448a.041.041,0,0,1,.055-.017.041.041,0,0,1,.018.055L5.35,38.845a.674.674,0,0,0,.872.929l3.433-1.543a.041.041,0,0,1,.054.02.041.041,0,0,1-.021.054L6.255,39.848a.758.758,0,0,1-.313.068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M11.221,39.266a.1.1,0,0,1-.029,0l-1.006-.3a.781.781,0,0,1-.487-.988.84.84,0,0,1,.368-.485.711.711,0,0,1,.577-.08l1.007.3a.1.1,0,1,1-.058.2l-1.007-.3a.517.517,0,0,0-.414.059.644.644,0,0,0-.278.368.578.578,0,0,0,.349.735l1.007.3a.1.1,0,0,1-.029.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M16.305,24.834l.765-.092a5.931,5.931,0,0,0-6.109-5.1c-.13,0-.26,0-.387.011a5.88,5.88,0,0,1,5.731,5.176"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M18.066,25.726c.1,1.036-.235,1.919-.758,1.971s-1.032-.744-1.136-1.78.234-1.918.757-1.971,1.032.744,1.137,1.78",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M17.493,26.13c0,2.832-2.807,5.128-6.269,5.128s-6.266-2.3-6.266-5.128S7.764,21,11.224,21s6.269,2.3,6.269,5.128",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M11.225,31.3c-3.478,0-6.308-2.319-6.308-5.169s2.83-5.169,6.308-5.169,6.308,2.319,6.308,5.169S14.7,31.3,11.225,31.3m0-10.256C7.791,21.043,5,23.325,5,26.13s2.793,5.088,6.227,5.088,6.227-2.283,6.227-5.088-2.793-5.087-6.227-5.087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M15.617,27.887c.075.969-1.452,1.878-3.412,2.03s-3.609-.51-3.684-1.479,1.452-1.879,3.412-2.031,3.609.511,3.684,1.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M11.132,28.294a.69.69,0,1,1-.676-.7.689.689,0,0,1,.676.7",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M14.629,28.069a.69.69,0,1,1-.676-.7.689.689,0,0,1,.676.7",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M5.6,26.374a5.132,5.132,0,0,1-.132-1.155,5.83,5.83,0,0,1,5.746-5.56q-.192-.012-.387-.012A5.873,5.873,0,0,0,4.7,25.219a5.1,5.1,0,0,0,.145,1.21c.254-.011.508-.03.761-.055",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M6.447,27.232c.236,1.014-.053,1.948-.644,2.085s-1.261-.574-1.5-1.588.052-1.948.643-2.085,1.261.574,1.5,1.588",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M5.45,28.7a.042.042,0,0,1-.04-.032.041.041,0,0,1,.031-.048c.1-.024.175-.159.207-.373a2.323,2.323,0,0,0-.056-.819,2.3,2.3,0,0,0-.311-.759c-.122-.178-.25-.266-.35-.243a.041.041,0,1,1-.018-.08c.137-.031.291.067.435.277a2.65,2.65,0,0,1,.38,1.636c-.037.252-.132.408-.269.44H5.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M10.088,40.864H20.6l3.064-6.788a.323.323,0,0,0-.294-.456H14.59a.321.321,0,0,0-.293.188l-2.863,6.223H9.772s-.013.833.316.833"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M20.633,40.1H11.722a.04.04,0,0,1-.04-.041.041.041,0,0,1,.04-.041h8.911a.041.041,0,0,1,.041.041.041.041,0,0,1-.041.041",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M32.985,35.845A5.727,5.727,0,0,0,30.824,33.8a1.938,1.938,0,0,1-.772,1.59,1.569,1.569,0,0,1-1.84-.009,1.343,1.343,0,0,1-.276-1.791,2.007,2.007,0,0,1,2.325-.324c.088.034.174.069.26.107A3.508,3.508,0,0,0,29.279,31.6a8.392,8.392,0,0,0-6.287-1.918,3.146,3.146,0,0,0-2.457,1.282l-.217-.123a3.374,3.374,0,0,1,2.646-1.407,8.639,8.639,0,0,1,6.477,1.975,3.571,3.571,0,0,1,1.36,2.1,5.973,5.973,0,0,1,2.4,2.209ZM29.17,33.3a1.229,1.229,0,0,0-1.033.438,1.1,1.1,0,0,0,.229,1.445,1.334,1.334,0,0,0,1.541,0,1.692,1.692,0,0,0,.664-1.47l0-.046c-.129-.062-.262-.119-.4-.171a2.878,2.878,0,0,0-1-.2",
    fill: "#fff"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeyondAi);
export default __webpack_public_path__ + "static/media/beyondAi.72e85c90ff1f96f79f766cf374468de1.svg";
export { ForwardRef as ReactComponent };